<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="project-list-container elevate">
  <div class="icon-text-container">
    <mat-icon class="crucible-icon-caster" svgIcon="ic_crucible_caster"></mat-icon>
    <span class="project-title text">My Projects</span>
    @if (canCreate$ | async) {
    <button
      mat-icon-button
      matTooltip="Add New Project"
      hotkeyAction="PROJECT_NEW"
      (click)="create()"
    >
      <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
    </button>
    }
    <div class="searchBox">
      <mat-form-field style="width: 320px">
        <input
          matInput
          [(ngModel)]="filterString"
          (keyup)="applyFilter($event.target.value)"
          #input
          placeholder="Search"
        />
        @if (filterString !== '') {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearFilter()"
          title="Clear Search"
        >
          <mat-icon
            style="transform: scale(0.85)"
            fontIcon="mdi-close-circle-outline"
          ></mat-icon>
        </button>
        }
      </mat-form-field>
    </div>
  </div>

  @if (projects) {
    <mat-table
      matSort
      matSortActive="name"
      matSortDirection="asc"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Name
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (!manageMode) {
          <a
            matTooltip="Open {{ element.name }}"
            [routerLink]="['/projects', element.id]"
            >{{ element.name }}</a
          >
          } @if (manageMode) {
          <a
            matTooltip="Edit {{ element.name }}"
            [routerLink]="['/projects', element.id, 'memberships']"
            ><p
              (click)="
                $event.preventDefault();
                $event.stopPropagation();
                selectProject(element.id)
              "
            >
              {{ element.name }}
            </p></a
          >
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Description
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.description }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dateCreated">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.dateCreated | date:'yyyy-MM-dd HH:mm' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (manageMode) {
          <a
            mat-icon-button
            matTooltip="Open {{ element.name }}"
            [routerLink]="['/projects', element.id]"
            target="_blank"
          >
            <mat-icon
              color="primary"
              fontIcon="mdi-open-in-new"
            ></mat-icon>
          </a>
          } @if ( (canManageAll$ | async) || (canManageProjects$ |
          async).includes(element.id) ) {
          <button mat-icon-button matTooltip="Rename" (click)="update(element)">
            <mat-icon
              color="primary"
              fontIcon="mdi-square-edit-outline"
            ></mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Delete {{ element.name }}"
            (click)="delete(element)"
          >
            <mat-icon
              color="primary"
              fontIcon="mdi-trash-can-outline"
            ></mat-icon>
          </button>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
      <tr class="mat-mdc-row" *matNoDataRow>
        <td class="mat-mdc-cell" colspan="4">
          @if (input.value) { No data matching the filter "{{ input.value }}" }
          @else { You are not a member of any Projects }
        </td>
      </tr>
    </mat-table>
    <!-- This non-displayed button is required, because hotKeys do not work with the button inside the mat-table -->
    <button
      style="display: none"
      hotkeyAction="PROJECT_NEW"
      (click)="createRequest()"
    ></button>
  }

  <!-- Loading Spinner -->
  @if (!projects || isLoading) {
  <mat-card
    appearance="outlined"
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </mat-card>
  }

  <mat-paginator
    [pageSizeOptions]="[10, 25, 50, 100]"
    showFirstLastButtons
    aria-label="Select page of projects">
  </mat-paginator>
</div>
